import React, { useEffect, useRef } from 'react';

/**
 * Renders raw HTML AND executes any <script> tags inside it.
 * React's dangerouslySetInnerHTML injects markup but never runs scripts,
 * so third-party embed widgets (Recruitee, forms, iframes-via-JS, etc.)
 * never initialise. This component re-creates each script element so the
 * browser executes it, supporting both inline and external (src) scripts.
 */
const HtmlWidget = ({ html, className = 'careers-html' }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Inject the markup
    el.innerHTML = html || '';

    // Re-create scripts so they execute
    const scripts = Array.from(el.querySelectorAll('script'));
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      if (oldScript.textContent) newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });

    return () => { el.innerHTML = ''; };
  }, [html]);

  return <div ref={ref} className={className} />;
};

export default HtmlWidget;
